// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"450922a5","138":"2225d915","266":"741ec842","330":"f7f8ca6e","384":"6c424e90","535":"e8db77b4","873":"f85c2a27","984":"31142dec"}[chunkId] + ".chunk.js";
};